import { omit } from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Link } from 'redux-little-router';

export default class LinkWrapper extends PureComponent {
  static propTypes = {
    href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    className: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    router: PropTypes.object.isRequired,
  };

  static defaultProps = {
    href: '#',
  };

  go() {}

  render() {
    const { children, href, router } = this.props;
    const linkProps = omit(this.props, ['router', 'children', 'dispatch']);

    linkProps.replaceState = router.route === href;

    return <Link {...linkProps}>{children}</Link>;
  }
}
